import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <p style={styles.text}>
                    We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
                </p>
                <button onClick={handleAccept} style={styles.button}>
                    Accept
                </button>
            </div>
        </div>
    );
};

const styles = {
    container: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        borderTop: '1px solid #ddd',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 99999,
        padding: '15px 20px',
    },
    content: {
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '10px'
    },
    text: {
        margin: 0,
        fontSize: '14px',
        color: '#333',
        flex: 1,
        minWidth: '250px'
    },
    button: {
        backgroundColor: '#007DB6', // Using the primary color found in global.css
        color: '#fff',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '600',
        whiteSpace: 'nowrap'
    }
};

export default CookieConsent;
